// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Home            from "./pages/Home";
import Track           from "./pages/Track";
import Request         from "./pages/Request";
import Login           from "./pages/Login";
import Admin           from "./pages/Admin";
import Rider           from "./pages/Rider";
import CustomerService from "./pages/CustomerService";
import About           from "./pages/About";
import Analytics       from "./pages/Analytics";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/"          element={<Home />} />
          <Route path="/track"     element={<Track />} />
          <Route path="/request"   element={<Request />} />
          <Route path="/about"     element={<About />} />
          <Route path="/login"     element={<Login />} />
          <Route path="/admin"     element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute role="admin"><Analytics /></ProtectedRoute>} />
          <Route path="/rider"     element={<ProtectedRoute role="rider"><Rider /></ProtectedRoute>} />
          <Route path="/cs"        element={<ProtectedRoute role="customer_service"><CustomerService /></ProtectedRoute>} />
          <Route path="*"          element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}